import { AccessibleSVG } from '@core/svg';
/**
 * Green Checkmark SVG Icon
 * source: https://react-icons.github.io/react-icons/search/#q=checkmark
 * icon name: IoIosCheckmarkCircle
 */
export const CheckmarkGreen = (props) => (<AccessibleSVG width="100%" height="100%" stroke="green" fill="green" strokeWidth="0" viewBox="0 0 512 512" {...props}>
    <path d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm106.5 150.5L228.8 332.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"></path>
  </AccessibleSVG>);
